import { Auth, getAuth } from "firebase/auth";
import React, { createContext, useState } from "react";

type AuthContextType = {
    user: Auth["currentUser"];
    isLoading: boolean;
};

const contextDefaultValues: AuthContextType = {
    user: null,
    isLoading: true,
};

export const AuthContext = createContext<AuthContextType>(contextDefaultValues);

export const AuthContextProvider: React.FC = ({ children }) => {
    const [authState, setAuthState] =
        useState<AuthContextType>(contextDefaultValues);

    React.useEffect(() => {
        return getAuth().onAuthStateChanged((user) =>
            setAuthState({
                user,
                isLoading: false,
            }),
        );
    }, []);

    return (
        <AuthContext.Provider value={authState}>
            {children}
        </AuthContext.Provider>
    );
};
